'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var CheckCircleOutline = require('../../../IconsAndImages/Icons/CheckCircleOutline.js');
var RemoveCircleOutline = require('../../../IconsAndImages/Icons/RemoveCircleOutline.js');
var Alert$1 = require('../../../node_modules/@material-ui/lab/esm/Alert/Alert.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var Alert = React__default["default"].forwardRef(function (props, ref) {
  return React__default["default"].createElement(Alert$1["default"], _objectSpread({
    ref: ref,
    iconMapping: {
      success: React__default["default"].createElement(CheckCircleOutline, null),
      info: React__default["default"].createElement(RemoveCircleOutline, null)
    }
  }, props));
});

module.exports = Alert;
